import { AppData, Registry } from "@lightningjs/sdk";
import { Logger } from "./logger";
import { AppSetup } from "./app-setup";
import { Helper } from "./helper";

const errorHandler = {

  initErrorReporting() {
      Logger.printLog('info', 'initErrorReporting called ', '');

      // window.onunhandledrejection = (event) =>{
      //   throw new Error(event.reason)
      // }

      window.onerror = (msg, url, lineNo, columnNo, error) => {
          Logger.printLog('error', 'printing error details: ', error.stack);
          var string = msg.toLowerCase();
          var substring = "script error";          
          if (string.indexOf(substring) > -1 || (msg && msg.indexOf('_isInitiatedSent')>-1)){
            Logger.printLog('error', 'Script Error: See Browser Console for Detail');
          } else {
              var message = [
                  'Message: ' + msg,
                  // 'URL: ' + url,
                  'Line: ' + lineNo,
                  // 'Column: ' + columnNo,
                  // 'Error object: ' + JSON.stringify(error)
                  'Error_object: ' + JSON.stringify(error.stack)
              ].join(' - ');

              Logger.printLog('error', 'error caught: ', message);
              Logger.processUserAction('javascriptErrorOccurred_' + message);

              if(msg.indexOf('TypeError') !== -1) {
                const {appConfig,platform} = AppData as AppSetup
                Helper.removeCookie('appHangAutoReloaded');
                Helper.setGeneralCookie('appHangAutoReloaded', "yes", 7);



                platform?.sendMetrics('error', {errorType: 'JS_ERROR', code: 'JS_ERROR', description:msg})



                  setTimeout(function(){
                      if(appConfig?.reloadOnError == true) {
                          window.location.reload();
                      }
                  }, 10000);
              }
          }

          return false;
      };
  }

}

export default errorHandler
